// V25 Batch B — Client-side image compression for Aadhaar uploads (and any
// other base64-over-JSON path). Returns a Promise<{ b64, mime, sizeBytes }>.
// Resizes the longest edge to `maxEdge` and re-encodes as JPEG quality 80%.
export function compressImage(file, { maxEdge = 1280, quality = 0.82 } = {}) {
    return new Promise((resolve, reject) => {
        if (!file) {
            reject(new Error("No file provided"));
            return;
        }
        const reader = new FileReader();
        reader.onerror = () => reject(new Error("Failed to read file"));
        reader.onload = () => {
            const img = new Image();
            img.onerror = () => reject(new Error("Invalid image"));
            img.onload = () => {
                const longest = Math.max(img.width, img.height);
                const scale = longest > maxEdge ? maxEdge / longest : 1;
                const w = Math.round(img.width * scale);
                const h = Math.round(img.height * scale);
                const canvas = document.createElement("canvas");
                canvas.width = w; canvas.height = h;
                const ctx = canvas.getContext("2d");
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, w, h);
                ctx.drawImage(img, 0, 0, w, h);
                const dataUrl = canvas.toDataURL("image/jpeg", quality);
                // dataUrl: "data:image/jpeg;base64,<...>"
                const [, b64] = dataUrl.split(",");
                resolve({
                    b64,
                    mime: "image/jpeg",
                    sizeBytes: Math.round((b64.length * 3) / 4),
                });
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    });
}
